import noPractitionersFoundIcon from '~/assets/images/no-practitioners-found.png';

export const NoItemsFound = () => {
  return (
    <div
      data-testid="no-items-found"
      className="flex flex-col items-center gap-1 p-4 pt-[25%]"
    >
      <div className="flex items-center justify-center py-6">
        <img
          src={noPractitionersFoundIcon}
          alt="Illustration showing no search results found"
          className="h-36 w-36"
        />
      </div>
      <span className="text-lg">No practitioners found</span>
      <span className="w-2/3 text-center text-md text-neutral-60">
        Try adjusting your filters or the service you&apos;re looking for.
      </span>
    </div>
  );
};
